import React, { useState, useEffect, useRef } from "react";
import { Row, Radio, Button, Dropdown, Menu, Select, Col } from "antd";
import { ConsoleSqlOutlined, DownOutlined } from "@ant-design/icons";
import "./BidAmount.css";
import dollar_pic from "../../../assets/img/dollar.png";
import ruppee_pic from "../../../assets/img/rupee.png";
import claritypeso_pic from "../../../assets/img/claritypeso.png";
import plus from "../../../assets/img/plus.png";
import { useDispatch, useSelector } from "react-redux";
import minus from "../../../assets/img/minus.png";
import { isHC, isNonHC } from "../../../shared/helpers";

export default function BidAmount(props) {
  const { Option } = Select;
  const [showWeekly, setShowWeekly] = useState(false);
  const [rateType, setRateType] = useState();
  const [minusPressed, setMinusPressed] = useState(false);
  // const [PressedCheck, setPressedCheck] = useState(true);
  const userSKillListing = useSelector(
    (state) => state.oneUserskillListingReducer.skillListings
  );
  const [timeoutId, setTimeoutId] = useState(null);
  const inputRef = useRef(null);

  useEffect(() => {
    setShowWeekly(userSKillListing?.skill_listings?.BudgetTypes?.BudgetTypeName);
  }, [userSKillListing])
  useEffect(() => {
    if(isNaN(props.rate) || props.rate == 0) {
      props?.setRateError(1.00);
    }
    else{
      props?.setRateError(0.00);
    }    
  }, [props.rate]);

  // useEffect(() => {
  //   if(props?.EditBid){
  //     if(PressedCheck){
  //       props?.setrate(props?.Bid_rate);
  //       props?.setrateType(props?.rateType);
  //     }
  //   }
  // }, [props])

  useEffect(()=>{
    if (isNonHC(props.professionCode)) {
      props.setrateType('Yearly')
      // setShowWeekly(true);
    } else if (isHC(props.professionCode)) {
      props.setrateType('Weekly')
      // setShowWeekly(true);
    }
  },[props.professionCode])
  
  let userProfile = JSON.parse(localStorage.getItem("userProfile"));
  
  // function onChange(value) {
  //   props.setcurrencyType(value);
  // }
  useEffect(() => {
    // if (props.rate > props.desiredRate){
      // props.setrate(props.rate)
      // if (props.EditBid == true) {
        // if (props.rate < props.Bid_rate) {
          // props.setrate(props.Bid_rate)
        // }else{
          props.setrate(props.rate)
        // }              
    //   else{
    //     props.setrate(props.rate)
    //   }
    // // }
    // else{
    //   props.setrate(props.desiredRate ?? 1);
    // }
  }, []);

  useEffect(() => {
    if (props.rateType === 1 || props.rateType === "Hour"){
      props.setrateType("Hour");
      setShowWeekly(false);
    }
    else if (props.rateType === 2 || props.rateType === "Week"){
      props.setrateType("Week");
      setShowWeekly(true);
    } else if(props.rateType === 4 ||  props.rateType === "Year"){
      props.setrateType("Year");
      setShowWeekly(true);
    } 
    else{
      if (isNonHC(props.professionCode)) {
        props.setrateType('Year')
        setShowWeekly(true);
      } else if (isHC(props.professionCode)) {
        props.setrateType('Week')
        setShowWeekly(true);
      }
    }
  }, [props.professionCode]);

  const handleInput = (event) => {
    const inputValue = event.target.value;
    if (event?.nativeEvent?.inputType == 'deleteContentBackward') {
      props.setrate(inputValue?.toString());
    }else{
      props?.setrate(parseFloat(inputValue)?.toFixed(2));
    }

    setTimeout(() => {
      const numberStr = String(inputValue)?.replace(/\.0+$/, "");
      inputRef.current.selectionStart = numberStr?.length;
      inputRef.current.selectionEnd = numberStr?.length;
    }, 50)
  };
  
  return (
    <div className="bid-amount-container">
      <Col xs={20} sm={20} md={15} lg={15} xl={15}>
        {!isHC(userProfile?.Professions?.ProfessionCode) ?
          (
            <Row className="HourlyWeeklyBidCont">
                <Button
            className={`btn-WK ${!showWeekly ? "btn-WK_active" : null}`}
            onClick={() => {
              setShowWeekly(false);
              props.setrateType("Hour");
            }}
          >
            Hourly
          </Button>
          
          <Button
            className={`btn-WK ${showWeekly ? "btn-WK_active" : null}`}
            onClick={() => {
              setShowWeekly(true);
              props.setrateType("Year");
            }}
          >
           Yearly
          </Button>
         </Row>
          ) :

          (
            <Row className="HourlyWeeklyBidCont">
          <Button
            className={`btn-WK ${showWeekly ? "btn-WK_active" : null}`}
            onClick={() => {
              setShowWeekly(true);
              props.setrateType("Week" );
            }}
          >
          Weekly
          </Button>

          <Button
            className={`btn-WK ${!showWeekly ? "btn-WK_active" : null}`}
            onClick={() => {
              setShowWeekly(false);
              props.setrateType("Hour");
            }}
          >
            Hourly
          </Button>
        </Row>
          ) } 
        <Row className="budgetType_PB_Dropdown">
          <div className="Currency-BG">USD - $</div>
          {/* <Select
            style={{ width: "150px" }}
            defaultValue={`${props.currencyType} - $`}
            // defaultValue={`USD - $`}
            onChange={onChange}
          >
            <Option value="USD">
              USD - <img src={dollar_pic} className="currency_icons" />
            </Option>
            <Option value="INR">
              INR - <img src={ruppee_pic} className="currency_icons" />
            </Option>
            <Option value="PESO">
              PESO - <img src={claritypeso_pic} className="currency_icons" />
            </Option>
            <Option value="CAD">
              CAD - <img src={dollar_pic} className="currency_icons" />
            </Option>
          </Select> */}
        </Row>

        <Row className="Amount_Container">
          <div
            className="iconContainer"
            onClick={() => {
              // if (props.rate <= props.desiredRate) {
              //   props.setrate(props.rate);
              //   setMinusPressed(true);
              // } else 
              // setPressedCheck(false)
              if (props.rate <= 0) {
                  props.setrate(0.00);
              } else {                
                props.setrate((+ parseFloat(props?.rate) - 1).toFixed(2));
              }
            }}
          >
            <img src={minus} alt="minus" className="icon" />  
          </div>
          {/* <div className="amount">{props.rate}</div> */}
          <input
            className="budget-input-holder"
            // type="text"
            ref={inputRef}
            placeholder={"0.00"}
            value={isNaN(props.rate) ? "" : props?.rate}
            onChange={(e) => handleInput(e)}
          />
          <div
            className="iconContainer"
            onClick={() => {
              // setPressedCheck(false);
              setMinusPressed(false)
              if (isNaN(props.rate)) {
                props?.setrate(1.0)
              } else {
                props?.setrate(
                  (+ parseFloat(props?.rate) + 1).toFixed(2)
                )

              }
            }}
          >
            <img src={plus} alt="plus" className="icon" />
          </div>
        </Row>
        {/* {props.rate < 1 ? (
          <div style={{color: 'red',justifyContent: 'center'}} >
            Please add an amount higer than 0 to move to the next step
          </div>
        ) : null
        } */}
        { props.rate <= 0 || isNaN(props.rate) ? (
          <Row className="candidate-desired-container">
            <div
              className={`candidate-desired-pay-msg candidate-desired-pay-msg-red
               `}
            >
              Please add a bid amount to proceed
            </div>
          </Row>
        ) : null}
      </Col>
    </div>
  );
}
